
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/[id]/edit",
      function () {
        return require("private-next-pages/jobs/[id]/edit.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/[id]/edit"])
      });
    }
  